import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=1da55ec1&"
import script from "./AddContact.vue?vue&type=script&lang=ts&"
export * from "./AddContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports